import { render, staticRenderFns } from "./App.vue?vue&type=template&id=bb16d3e0&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=bb16d3e0&prod&scoped=true&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=bb16d3e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb16d3e0",
  null
  
)

export default component.exports